'use client'
import { ThemeContext } from '@/app/components/theme'
import { themes } from '@/app/themes'
import { useRouter } from 'next/navigation'
import { useContext } from 'react'
import Modal from '../util/modal'

export const themeModalId = 'theme-modal'
const ThemeModal = () => {
    const router = useRouter()
    const { theme: currentTheme, setTheme } = useContext(ThemeContext)
    return (
        <Modal id={themeModalId} title="Choose Theme">
            {themes.map((theme) => {
                const isActive = theme === currentTheme
                const className = `btn ${isActive ? 'btn-primary' : ''}`
                return (
                    <div
                        onClick={async () => {
                            await setTheme(theme)
                            router.refresh()
                        }}
                        key={theme}
                        className={className}
                        aria-label={theme}
                        data-set-theme={theme}
                    >
                        {theme}
                    </div>
                )
            })}
        </Modal>
    )
}
export default ThemeModal
